/* eslint-disable no-use-before-define */

import months from '../../Shared/months.json';

export function usePreviewtoString(detail, lang, logo, cookieList, width) {
    const cookiePolicy = detail?.cookiePolicy;
    const cookieAreUsed = detail?.cookieAreUsed;
    const cookieIntroductionLawfulBasis = detail?.cookieIntroductionLawfulBasis;
    const cookiePolicyChange = detail?.cookiePolicyChange;
    const cookiePreferences = detail?.cookiePreferences;

    const formatMonth = (month) => {
        const item = months.find((res) => res.id === month + 1);
        return lang === 'TH' ? item?.monthTh : item?.monthEn;
    };

    const formatYear = (year) => {
        return lang === 'TH' ? year + 543 : year;
    };

    const allCheck = (category) => {
        let check = category?.filter((res) => res?.isEnable);
        return check?.length;
    };

    const getCurrentDate = (date) => {
        const updateDate = date?.split(' ')[0];
        const dateItem = `${updateDate?.split('/')[1]}/${
            updateDate?.split('/')[0]
        }/${updateDate?.split('/')[2]}`;
        const currentDate = new Date(dateItem);
        const day = currentDate?.getDate();
        const month = formatMonth(Number(currentDate.getMonth()));
        const year = formatYear(Number(currentDate.getFullYear()));
        const formatDate = `${day} ${month} ${year}`;
        return formatDate;
    };
    let date = '';
    if (cookiePolicy?.updateDate) {
        const split = cookiePolicy?.updateDate.split('/');
        const year = split[2].split(' ');
        date = `_${split[0]}-${split[1]}-${year[0]}_`;
    }

    const body = `
    <body style="word-break: break-word;">
        <center>
        ${
            logo &&
            `<img
            width=${width} height="100"
        style="object-fit: cover;"
        src=${logo}
        alt="logo "/>`
        }</center>
        <center>
            <h3>
                ${
                    lang === 'TH'
                        ? cookiePolicy?.cookieCompanyNameTh
                        : cookiePolicy?.cookieCompanyNameEn
                }
            </h3>
        </center>
            <p className="text-left">
                ${
                    cookieIntroductionLawfulBasis?.cookieIntroductionIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? cookieIntroductionLawfulBasis?.cookieIntroductionContentTh ||
                              '-'
                            : cookieIntroductionLawfulBasis?.cookieIntroductionContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    cookieIntroductionLawfulBasis?.cookieWhatAreIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? cookieIntroductionLawfulBasis?.cookieWhatAreTitleTh
                            : cookieIntroductionLawfulBasis?.cookieWhatAreTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    cookieIntroductionLawfulBasis?.cookieWhatAreIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? cookieIntroductionLawfulBasis?.cookieWhatAreContentTh ||
                              '-'
                            : cookieIntroductionLawfulBasis?.cookieWhatAreContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    cookieIntroductionLawfulBasis?.cookieBenefitIsDisplay ===
                    true
                        ? lang === 'TH'
                            ? cookieIntroductionLawfulBasis?.cookieBenefitTitleTh
                            : cookieIntroductionLawfulBasis?.cookieBenefitTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
            ${
                cookieIntroductionLawfulBasis?.cookieBenefitIsDisplay === true
                    ? lang === 'TH'
                        ? cookieIntroductionLawfulBasis?.cookieBenefitContentTh ||
                          '-'
                        : cookieIntroductionLawfulBasis?.cookieBenefitContentEn ||
                          '-'
                    : ''
            }
        </p>
        <h4>
            ${
                cookieAreUsed?.cookieHowDoIsDisplay === true
                    ? lang === 'TH'
                        ? cookieAreUsed?.cookieHowDoTitleTh
                        : cookieAreUsed?.cookieHowDoTitleEn
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
            ${
                cookieAreUsed?.cookieHowDoIsDisplay === true
                    ? lang === 'TH'
                        ? cookieAreUsed?.cookieHowDoContentTh || '-'
                        : cookieAreUsed?.cookieHowDoContentEn || '-'
                    : ''
            }
        </p>
        <h4>
            ${
                cookieAreUsed?.cookieWhatTypeIsDisplay === true
                    ? lang === 'TH'
                        ? cookieAreUsed?.cookieWhatTypeTitleTh
                        : cookieAreUsed?.cookieWhatTypeTitleEn
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
            ${
                cookieAreUsed?.cookieWhatTypeIsDisplay === true
                    ? `${
                          cookieList &&
                          cookieList?.cookieCategoryList?.length > 0 &&
                          allCheck(cookieList?.cookieCategoryList)
                              ? `
                        ${cookieList?.cookieCategoryList
                            ?.map((item) => {
                                if (!item?.isEnable) {
                                    return `
                                        <h4>
                                            • ${
                                                lang === 'TH'
                                                    ? item?.cookieCategoryNameTh
                                                    : item?.cookieCategoryNameEn
                                            }
                                        </h4>
                                        <p>
                                            ${
                                                lang === 'TH'
                                                    ? item?.descriptionTh
                                                    : item?.descriptionEn
                                            }
                                        </p>
                                        ${
                                            item?.cookieList?.length > 0
                                                ? `
                                                <table>
                                                    <tr>
                                                        <th>${
                                                            lang === 'TH'
                                                                ? 'ชื่อคุกกี้'
                                                                : 'Cookie name'
                                                        }</th>
                                                        <th>Provider</th>
                                                        <th>${
                                                            lang === 'TH'
                                                                ? 'ระยะเวลา'
                                                                : 'Expiry'
                                                        }</th>
                                                        <th>${
                                                            lang === 'TH'
                                                                ? 'รายละเอียด'
                                                                : 'Cookie Purpose'
                                                        }</th>
                                                    </tr>
                                                    ${item?.cookieList
                                                        ?.map((val) => {
                                                            return `<tr>
                                                                <td>${
                                                                    val?.cookieName ||
                                                                    '-'
                                                                }</td>
                                                                <td>${
                                                                    val?.provider ||
                                                                    '-'
                                                                }</td>
                                                                <td>${
                                                                    val?.duration ||
                                                                    '-'
                                                                }</td>
                                                                <td>${
                                                                    val?.description ||
                                                                    '-'
                                                                }</td>
                                                            </tr>`;
                                                        })
                                                        .join('')}
                                                </table>
                                            `
                                                : `<table>
                                                <tr>
                                                    <td>
                                                        <center>${
                                                            lang === 'TH'
                                                                ? 'ไม่พบคุกกี้ในประเภทคุกกี้นี้'
                                                                : 'No cookies were found in this cookie category.'
                                                        }</center>
                                                    </td>
                                                </tr>
                                            </table>`
                                        }
                                    `;
                                }
                                return '';
                            })
                            .join('')}
                    `
                              : `<p>-</p>`
                      }`
                    : ''
            }
        </p>
        <h4>
            ${
                cookiePreferences?.cookieSettingIsDisplay === true
                    ? lang === 'TH'
                        ? cookiePreferences?.cookieSettingTitleTh || '-'
                        : cookiePreferences?.cookieSettingTitleEn || '-'
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
            ${
                cookiePreferences?.cookieSettingIsDisplay === true
                    ? lang === 'TH'
                        ? cookiePreferences?.cookieSettingContentTh || '-'
                        : cookiePreferences?.cookieSettingContentEn || '-'
                    : ''
            }
        </p>
        <h4>
            ${
                cookiePreferences?.cookieThirdPartyIsDisplay === true
                    ? lang === 'TH'
                        ? cookiePreferences?.cookieThirdPartyTitleTh || '-'
                        : cookiePreferences?.cookieThirdPartyTitleEn || '-'
                    : ''
            }
        </h4>
        <p className="indent-8 text-left">
                ${
                    cookiePreferences?.cookieThirdPartyIsDisplay === true
                        ? lang === 'TH'
                            ? cookiePreferences?.cookieThirdPartyContentTh ||
                              '-'
                            : cookiePreferences?.cookieThirdPartyContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    cookiePolicyChange?.cookieChangeIsDisplay === true
                        ? lang === 'TH'
                            ? cookiePolicyChange?.cookieChangeTitleTh
                            : cookiePolicyChange?.cookieChangeContentEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    cookiePolicyChange?.cookieChangeIsDisplay === true
                        ? lang === 'TH'
                            ? cookiePolicyChange?.cookieChangeContentTh || '-'
                            : cookiePolicyChange?.cookieChangeContentEn || '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    cookiePolicyChange?.cookieDataControllerIsDisplay === true
                        ? lang === 'TH'
                            ? cookiePolicyChange?.cookieDataControllerTitleTh
                            : cookiePolicyChange?.cookieDataControllerTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    cookiePolicyChange?.cookieDataControllerIsDisplay === true
                        ? lang === 'TH'
                            ? cookiePolicyChange?.cookieDataControllerContentTh ||
                              '-'
                            : cookiePolicyChange?.cookieDataControllerContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>
                ${
                    cookiePolicyChange?.cookieDataProtectionIsDisplay === true
                        ? lang === 'TH'
                            ? cookiePolicyChange?.cookieDataProtectionTitleTh
                            : cookiePolicyChange?.cookieDataProtectionTitleEn
                        : ''
                }
            </h4>
        <p className="indent-8 text-left">
                ${
                    cookiePolicyChange?.cookieDataProtectionIsDisplay === true
                        ? lang === 'TH'
                            ? cookiePolicyChange?.cookieDataProtectionContentTh ||
                              '-'
                            : cookiePolicyChange?.cookieDataProtectionContentEn ||
                              '-'
                        : ''
                }
            </p>
        <h4>${lang === 'TH' ? 'ฉบับ ณ วันที่' : 'Edition as of'}&nbsp;&nbsp;
                ${getCurrentDate(cookiePolicy?.effectiveDate)}</h4>
        <script type="text/javascript">
                $(document).ready(function() {
                let allElements = $('*');
                let converted = htmlDocx.asBlob(allElements.html());
                saveAs(converted, '${
                    lang === 'TH'
                        ? cookiePolicy?.cookiePolicyNameTh + `${date}TH.docx`
                        : cookiePolicy?.cookiePolicyNameEn + `${date}EN.docx`
                }');
                setTimeout(()=> window.close(), 100)
                });
        </script>
            </body>
    `;

    return {
        html: `
        <html>
        <head>
            <meta charset="UTF-8" />
            <title>Document</title>
            <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js"></script>
            <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
            <style>
                table {
                    border-collapse: collapse;
                    width: 100%;
                }
                
                td, th {
                    border: 2px solid #FFF;
                    text-align: left;
                    padding: 8px;
                }
                
                tr {
                    background-color: #F9F9F9;
                }
            </style>
        </head>
            ${body}
        </html>`,
        body,
    };
}
